import React from 'react';
import Ship from './Ship';
import ShipDescription from './ShipDescription';

class ShipGenerator extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      ships: [...Array(20).keys()],
      next_id: 20, 
      show_number: false,
      dimensions: {
        width: 1400, 
        height: 800
      }
    };
    this.add_ship = this.add_ship.bind(this);
    this.rmv_ship = this.rmv_ship.bind(this);
    this.dsc_ship = this.dsc_ship.bind(this);
  }

  add_ship() {
    let next_ships = this.state.ships;
    next_ships.push(this.state.next_id);
    this.setState({
      ships: next_ships,
      next_id: this.state.next_id+1
    });
  }

  rmv_ship(id) {
    let next_ships = this.state.ships;
    next_ships.splice(next_ships.indexOf(id), 1);
    this.setState({
      ships: next_ships
    });
  }

  dsc_ship(number) {
    this.setState({
      show_number: number
    });
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ 
        dimensions : {
          width: this.container.offsetWidth,
          height: this.container.offsetHeight
        }
      });
    }, 15);
  }
  
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    let tools = {
      add_ship: this.add_ship,
      rmv_ship: this.rmv_ship,
      dsc_ship: this.dsc_ship
    };
    let ships = this.state.ships.map(id => <Ship key={id} id={id} bounds={this.state.dimensions} tools={tools}/>);
    return (
      <div className="Space" ref={e => (this.container = e)}>
        <div className="Spacer"></div>
        {this.state.show_number && <ShipDescription id={this.state.show_number} data={this.props.data}/>}
        {ships}
      </div>
    );
  }
}

export default ShipGenerator;